// extracted by mini-css-extract-plugin
export default {"aboutBg":"Support_aboutBg__q8zJ3"};